import { graphql, useStaticQuery } from "gatsby"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"
import React, { useState } from "react"
import "twin.macro"

type dataType = {
  allPortfolioJson: {
    nodes: {
      dector: boolean
      art: boolean
      interior: boolean
      image: ImageDataLike
    }[]
  }
}
const Portfolio = () => {
  const data: dataType = useStaticQuery(graphql`
    query MyQuery {
      allPortfolioJson {
        nodes {
          dector
          art
          interior
          image {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
            }
          }
        }
      }
    }
  `)

  const AllData = data.allPortfolioJson.nodes

  const Art = data.allPortfolioJson.nodes.filter(arr => arr.art === true)
  const dector = data.allPortfolioJson.nodes.filter(arr => arr.dector === true)
  const interior = data.allPortfolioJson.nodes.filter(
    arr => arr.interior === true
  )

  const [portfolioData, setPortfolioData] = useState(AllData)
  const ButtonData = [
    {
      title: "All",
      onclick: () => setPortfolioData(AllData),
    },
    {
      title: "Decor",
      onclick: () => setPortfolioData(dector),
    },
    {
      title: "Art",
      onclick: () => setPortfolioData(Art),
    },
    {
      title: "Interior",
      onclick: () => setPortfolioData(interior),
    },
  ]

  return (
    <div>
      <div tw="bg-white max-w-3xl md:col-span-5 shadow-2xl">
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-6 pl-6">PORTFOLIO</h1>
        <div tw=" p-4 space-x-3 ">
          {ButtonData.map((item, index) => (
            <button
              onClick={item.onclick}
              key={index}
              tw=" font-semibold opacity-50 hover:opacity-100"
            >
              {item.title}
            </button>
          ))}
        </div>
        <div tw="grid md:grid-cols-3 pl-4 pr-4 pb-4">
          {portfolioData.map((item, index) => {
            const image = getImage(item.image)

            return (
              <div
                className="group "
                tw="relative border border-gray-50"
                key={index}
              >
                <GatsbyImage image={image as IGatsbyImageData} alt="photo" />
                <div tw="absolute w-full transition-opacity duration-300 h-full top-0 bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 ">
                  <div tw="text-gray-50 text-center  p-10">my photos</div>
                  <div tw="ml-16">
                    <button tw="bg-blue-400 text-white font-bold py-1 px-2 rounded-full content-center">
                      View more
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
export default Portfolio
